import { columnHelper } from './helper';

export const host = columnHelper.accessor((row) => row.NodeName || '-', {
  header: '主机',
  id: 'host',
});
